const TOKEN_KEY = 'micon_admin_token'
const AUTH_EXPIRED_FLAG_KEY = 'micon_admin_auth_expired'
const AUTH_REDIRECT_FLAG = '__miconAuthRedirect'

let redirectingToLogin = false

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || ''
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token || '')
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY)
}

export function markAuthRedirectError(error) {
  const target = error instanceof Error
    ? error
    : new Error('\u4f1a\u8bdd\u5df2\u8fc7\u671f\uff0c\u8bf7\u91cd\u65b0\u767b\u5f55')
  target[AUTH_REDIRECT_FLAG] = true
  return target
}

export function isAuthRedirectError(error) {
  return Boolean(error && error[AUTH_REDIRECT_FLAG])
}

export function redirectToLogin() {
  clearToken()

  if (typeof window === 'undefined') {
    return
  }

  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.setItem(AUTH_EXPIRED_FLAG_KEY, '1')
  }

  const basePath = process.env.BASE_URL || '/'
  const normalizedBasePath = basePath === '/' ? '' : basePath.replace(/\/$/, '')
  const loginPath = `${normalizedBasePath}/login`
  const currentPath = window.location.pathname || ''
  if (currentPath === loginPath || redirectingToLogin) {
    return
  }

  redirectingToLogin = true
  window.location.replace(loginPath)
}

export function consumeAuthExpiredFlag() {
  if (typeof sessionStorage === 'undefined') {
    return false
  }

  const value = sessionStorage.getItem(AUTH_EXPIRED_FLAG_KEY) === '1'
  if (value) {
    sessionStorage.removeItem(AUTH_EXPIRED_FLAG_KEY)
  }
  return value
}
